'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Select = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Select, _React$Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Select, [{
    key: 'onChange',
    value: function onChange(item) {
      var items = this.props.multi ? item : item ? [item] : [];
      if (items.length) {
        var values = items.map(function (item) {
          return item.value;
        });
        var finalValue = this.props.multi ? values : values[0];
        this.props.onChange(finalValue);
      } else {
        this.props.onChange(null);
      }
    }
  }, {
    key: 'loadOptions',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(input, callback) {
        var options;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.loadOptions(input);

              case 2:
                options = _context.sent;

                callback(null, { options: options });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadOptions(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: 'filterOption',
    value: function filterOption() {
      var _props;

      if (this.props.filterOption) return (_props = this.props).filterOption.apply(_props, arguments);
      return true;
    }
  }, {
    key: 'getFilterOption',
    value: function getFilterOption() {
      if (!this.props.loadOptions) return { options: this.props.options };
      return { filterOption: this.filterOption, loadOptions: this.loadOptions };
    }
  }, {
    key: 'render',
    value: function render() {
      var Comp = this.props.loadOptions ? _reactSelect.AsyncCreatable : _reactSelect.Creatable;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Comp, (0, _extends3.default)({
          multi: this.props.multi,
          name: this.props.fieldName,
          value: this.props.value,
          isValidNewOption: this.props.isValidNewOption,
          onChange: this.onChange
        }, this.getFilterOption(), this.props.passProps)),
        _react2.default.createElement(
          'div',
          { className: 'os-input-error' },
          this.props.errorMessage
        )
      );
    }
  }]);
  return Select;
}(_react2.default.Component), _class2.propTypes = {
  fieldName: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  passProps: _propTypes2.default.object,
  multi: _propTypes2.default.bool,
  options: _propTypes2.default.array,
  errorMessage: _propTypes2.default.node,
  loadOptions: _propTypes2.default.func,
  isValidNewOption: _propTypes2.default.func,
  filterOption: _propTypes2.default.func
}, _class2.defaultProps = {
  isValidNewOption: function isValidNewOption() {
    return false;
  }
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadOptions', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'loadOptions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'filterOption', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'filterOption'), _class.prototype)), _class);
exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/Select/index.js
// module id = 1998
// module chunks = 7 12 22 31 37